export default "__VITE_ASSET__BYfHuu5r__"